// extracted by mini-css-extract-plugin
export default {"editor":"draft-editor_editor__pXoLn"};